import type { DeviceType } from '@weberus/shared-types';
import { Device } from '@weberus/shared-types';
import { yaNative } from '@weberus/ui/utils/ya-native';
import { UAParser } from '@weberus/utils';

export const IOS_INSTALL = 'https://yanolja.onelink.me/tmFm';
export const ANDROID_INSTALL_WEB = 'https://play.google.com/store/apps/details?id=com.cultsotry.yanolja.nativeapp';
export const ANDROID_INSTALL = 'market://details?id=com.cultsotry.yanolja.nativeapp';

export const redirectTo = (link: string, device: DeviceType, failoverLink?: string | null) => {
  if (yaNative.isEnabled) {
    yaNative.canOpen({ link }, (completion, ret) => {
      if (!completion) {
        redirectToWithCheckTimer(link, device);
        return;
      }

      if (ret.installed) {
        window.location.href = link;
        return;
      }

      if (failoverLink) {
        try {
          window.location.href = failoverLink;
        } catch (e) {
          redirectToInstallPage(device);
        }
      } else {
        redirectToInstallPage(device);
      }
    });
  } else {
    redirectToWithCheckTimer(link, device, failoverLink);
  }
};

export function redirectToWithCheckTimer(link: string, device: DeviceType, failoverLink?: string | null): void {
  const clickedAt = +new Date();

  window.setTimeout(() => {
    if (+new Date() - clickedAt < 2000 && !window.document.hidden) {
      if (failoverLink) {
        try {
          window.location.href = failoverLink;
        } catch (error) {
          redirectToInstallPage(device);
        }
      }
      redirectToInstallPage(device);
    }
  }, 1500);
  window.location.href = link;
}

export function redirectToInstallPage(device: DeviceType): void {
  if (device === Device.ios) {
    window.location.href = IOS_INSTALL;
    return;
  }

  if (device === Device.android) {
    redirectTo(ANDROID_INSTALL, device, ANDROID_INSTALL_WEB);
    return;
  }

  // 이미 /app/install 이면, macOS일 때 App Store, 아닐 때 Play Store
  if (location.pathname === '/app/install') {
    const ua = new UAParser();
    ua.getOS().name === 'Mac OS' ? (location.href = IOS_INSTALL) : (location.href = ANDROID_INSTALL_WEB);
    return;
  }

  // 나머지 모두 /app/install
  location.href = '/app/install';
}
